import axios from "axios";
import React from "react";
import { useState } from "react"
import { Link } from 'react-router-dom';
import { Form, Button ,FloatingLabel} from 'react-bootstrap';

const AcpSalesPartner = () => {

    const [name, setName] = useState('')
    const [number, setNumber] = useState('')
    const [email, setEmail] = useState('')
    const [pincode, setPincode] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [country, setCountry] = useState('')
    const [message1, setMessage1] = useState('')
    const [statusCode, setStatusCode] = useState('')
    const [message, setMessage] = useState('')

    const API_PATH = 'http://amosta.com/reactJs/ACPregistrationInsert.php';
    const API_PATH1 = 'http://amosta.com/reactJs/acpSalesPartner.php';
    function axios2() {

        axios({
            method: 'post',
            url: API_PATH,
            headers: {
                'content-type': 'application/json'
               
            },
            data: {
                
                "name": name,
                "number": number,
                "email": email,
                "pincode": pincode,
                "city": city,
                "state": state,
                "country": country,
                "message1": message1
              
            }
        })
            .then(result => {
                if (result.data.statusCode === 200) {
                    setStatusCode(result.data.statusCode)
                    setMessage(result.data.message)
                    window.location.reload(false)
                } else {
                    setStatusCode(result.data.statusCode)
                    setMessage(result.data.message)
                }
                console.log(result);
            })
            .catch(error => {
                console.log(error)
            });
    }
    function axios3() {

        axios({
            method: 'post',
            url: API_PATH1,
            headers: {
                'content-type': 'application/json'
               
            },
            data: {
                
                "name": name,
                "number": number,
                "email": email,
                "pincode": pincode,
                "city": city,
                "state": state,
               
                "message1": message1
              
            }
        })
            .then(result => {
                if (result.data.statusCode === 200) {
                    setStatusCode(result.data.statusCode)
                    setMessage(result.data.message)
                    window.location.reload(false)
                } else {
                    setStatusCode(result.data.statusCode)
                    setMessage(result.data.message)
                }
                console.log(result);
            })
            .catch(error => {
                console.log(error)
            });
        }
    return (
        <div>
            <img className='img-fluid acp-types-background-img' src="./assets/images/acp-background.jpg" alt="" />
            <div className="container acp-sales-partner-section-1">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <img src="assets/images/acp-logo-lg.png" alt="" className="img-fluid w-50" />
                        <h1 className='pt-3'>ACP Sales Partner</h1>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="container gst-software-first-form p-5 bg-white text-dark text-center border-0 rounded-2 shadow-lg w-100" style={{ marginTop: '50px' }}>
                        <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6"> <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                        <Form.Control type='text' placeholder='Full Name' id='name' name='name' onChange={(e) => setName(e.target.value)}  required />
                                    </FloatingLabel></div>
                                    <div className="col-sm-12 col-md-6"> <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                        <Form.Control type='email' name='email' placeholder='name@example.com' id='email' onChange={(e) => setEmail(e.target.value)} required />
                                    </FloatingLabel></div>
                                    <div className="col-sm-12 col-md-6"><FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                        <Form.Control type='number' placeholder='Phone number' id='number' name='number' onChange={(e) => setNumber(e.target.value)} required />
                                    </FloatingLabel></div>
                                    <div className="col-sm-12 col-md-6"><FloatingLabel controlId='pincode' label='Pin Code' className='mb-3'>
                                        <Form.Control type='number' placeholder='Pin Code' id='pincode' name='pincode' onChange={(e) => setPincode(e.target.value)} required />
                                    </FloatingLabel></div>
                                    <div className="col-sm-12 col-md-6"><FloatingLabel controlId='city' label='City' className='mb-3'>
                                        <Form.Control type='text' placeholder='City' id='city' name='city' onChange={(e) => setCity(e.target.value)} required />
                                    </FloatingLabel></div>
                                    <div className="col-sm-12 col-md-6"><FloatingLabel controlId='state' label='State' className='mb-3'>
                                        <Form.Control type='text' placeholder='State' name='state' id='state' onChange={(e) => setState(e.target.value)} required />
                                    </FloatingLabel></div>
                                    <FloatingLabel controlId="floatingTextarea2" label="Message" className='mb-3'>
                                        <Form.Control as="textarea" placeholder="Leave a comment here" id='message1' name='message1'style={{ height: '100px' }} onChange={(e) => setMessage1(e.target.value)} />
                                    </FloatingLabel>
                                </div>
                                <div className="submit-button">
                                    <Button type='button' onClick={axios3} variant='success' className='btn w-25 p-2'>Submit</Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-light p-5">
                <div className="acp-sales-section-2 mt-5 text-center">
                    <h1>About ACP Sales Partner</h1>
                    <p className='p-3'><span className='fw-bold fs-5' style={{ color: "#f16136" }}>AMOSTA CONNECT PARTNER - SALES ( ACP-SALES )</span> is the sales partner who is feet on street partner.</p>
                </div>
            </div>

            <div className="conatiner mt-5 p-3">
                <h2 className='text-center p-4'>Eligibility for ACP Sales Partner</h2>
                <div className="card shadow-lg w-75 mx-auto p-3">
                    <ul>
                        <li><p>Minimum 18 years of age.</p></li>
                        <li><p>Citizen of India.</p></li>
                        <li><p>Able to read, write & speak any one of Indian local language in the territory.</p></li>
                    </ul>
                </div>
            </div>

            <div className="bg-light">
                <div className="conatiner mt-5 p-3">
                    <h2 className="text-center p-4">Expectations from ACP Sales Partner</h2>
                    <div className="card shadow-lg w-75 mx-auto p-3 bg-light">
                        <ul>
                            <li><p>Educate the customer about our products and services.</p></li>
                            <li><p>Carry out sales / collection / repeat sales as per Sales Procedure.</p></li>
                            <li><p>Customer relation & basic on - going Customer Service.</p></li>
                            <li><p>Coordinate with after sales services to ensure customer satisfaction.</p></li>
                            <li><p>Attend time-to-time sales and technical training progams.</p></li>
                            <li><p>One should maintain data confidentiality and sanity.</p></li>
                            <li><p>One also has a choice of attending time-to-time training conducted by Amosta either at Head Office or nearby his location.</p></li>
                            <li><p>Part time or Full time working hours.</p></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="conatiner mt-5 mb-5 p-5 text-center">
                <h1 className='p-5'>Different Types of ACP</h1>
                {/* <div className="acp-cards">
                    <div className="row">
                        <div className="col-sm-6 col-md-4">
                            <div className='container mt-4'>
                                <Link style={{ textDecoration: 'none' }} to='/acp-sales-partner'><div className="acp-card shadow-lg text-dark">
                                    <div className="acp-card-head mt-2">
                                    </div>
                                    <div className="acp-card-body mt-3">
                                        <h3>ACP Sales Partner</h3>
                                    </div>
                                </div></Link>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/humhai-seva-kendra'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>Hum hai Seva Kendra</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-execution-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP Execution Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-system-integration-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP System Integration Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-service-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP Service Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-marketing-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP Marketing Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-distributor-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP Distributor Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                        <div className="col-sm-6 col-md-4"><div className='container mt-4'>
                            <Link style={{ textDecoration: 'none' }} to='/acp-liaison-partner'><div className="acp-card shadow-lg text-dark">
                                <div className="acp-card-head mt-2">
                                </div>
                                <div className="acp-card-body mt-3">
                                    <h3>ACP Liaison Partner</h3>
                                </div>
                            </div></Link>
                        </div></div>
                    </div>
                </div> */}



                <div className="section5-cards">
                    <Link style={{ textDecoration: 'none' }} to='/acp-sales-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Sales Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Sales Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Sales Partner</h5>
                            <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/humhai-seva-kendra'>
                    <div className="card section-5-card shadow mt-4">
                        <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Hum hai seva kendra-Red.png' />
                        <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Hum hai seva kendra-White.png' />
                        <h5 className='section5-card-text mt-3'>Hum hai Seva Kendra</h5>
                         <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                    </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-execution-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Execution Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Execution Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Execution Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-system-integration-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP System Integration Partne-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP System Integration Partne-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP System Integration Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-service-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Service Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Service Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Service Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-marketing-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Marketing Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Marketing Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Marketing Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-distributor-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Distributor Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Distributor Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Distributor Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                    <Link style={{ textDecoration: 'none' }} to='/acp-liaison-partner'>
                        <div className="card section-5-card shadow mt-4">
                            <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/ACP Liaison Partner-Red.png' />
                            <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/ACP Liaison Partner-White.png' />
                            <h5 className='section5-card-text mt-3'>ACP Liaison Partner</h5>
                             <Button className="btn-sm mt-3 acp-know-more-btn-white" variant="light">Know More</Button>
                            <Button className="btn-sm mt-3 acp-know-more-btn" variant="danger">Know More</Button>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="bg-light p-5">
                <h3 className='p-2 text-center'>ACP Registraion Form</h3>
                <div className="container bg-white p-5 border w-50">
                <h5>{statusCode}</h5>
                <h5>{message}</h5>
                    <Form autoComplete="off">
                    <div className='mb-3 form-floating'>
                    <input type="text" className="form-control" id="name" name='name' placeholder="Full Name" onChange={(e) => setName(e.target.value)} required />
                    <label htmlFor="name">Full Name</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="number" className="form-control" id="number" name='number' placeholder="Mobile Number" onChange={(e) => setNumber(e.target.value)} required />
                    <label htmlFor="number">Mobile Number</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="email" className="form-control" id="email" name='email' placeholder="Email" onChange={(e) => setEmail(e.target.value)} required />
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="number" className="form-control" id="pincode" name='pincode' placeholder="Pincode" onChange={(e) => setPincode(e.target.value)} required />
                    <label htmlFor="pincode">Pincode</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="text" className="form-control" id="city" name='city' placeholder="City" onChange={(e) => setCity(e.target.value)} required />
                    <label htmlFor="city">City</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="text" className="form-control" id="state" name='state' placeholder="State" onChange={(e) => setState(e.target.value)} required />
                    <label htmlFor="state">State</label>
                  </div>
                  <div className='mb-3 form-floating'>
                    <input type="text" className="form-control" id="country" name='country' placeholder="Country" onChange={(e) =>setCountry(e.target.value)} required />
                    <label htmlFor="country">Country</label>
                  </div>
                
                      <div className='mb-3 form-floating'>
                    <textarea id='message1' name='message1' className='form-control' placeholder='Enter a Message' style={{height: '100px'}} onChange={(e) => setMessage1(e.target.value)} required />
                    <label htmlFor="message1">Enter a Message</label>
                  </div>
                        <div className="submit-button">
                            <Button type='button' variant='success' onClick={axios2} className='btn w-25 p-2'>Submit</Button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}
export default AcpSalesPartner;

